import Factory from '../factory';

const schema = Factory.schema('podcast');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('code').setType(String);

export default schema;
